export default "__VITE_ASSET__be562501__"